import { Link } from 'react-router-dom'
import type { ProjectSummary } from '../lib/project'

export function ProjectCard({ project, fromExplore = false, onExploreNavigate }: { project: ProjectSummary; fromExplore?: boolean; onExploreNavigate?: (shareSlug: string) => void }) {
  const songTitle = project.youtubeTitle || project.title
  const channel = project.youtubeChannelTitle?.trim()
  const creator = project.creatorName ?? '匿名使用者'

  return (
    <article className="project-card">
      <Link className="project-thumbnail" data-explore-card={fromExplore ? project.shareSlug ?? undefined : undefined} to={`/share/${project.shareSlug}`} state={fromExplore ? { fromExplore: true } : undefined} onClick={() => project.shareSlug && onExploreNavigate?.(project.shareSlug)} aria-label={`播放「${songTitle}」`}>
        <img
          src={`https://i.ytimg.com/vi/${project.youtubeVideoId}/hqdefault.jpg`}
          alt={`${songTitle} 的 YouTube 縮圖`}
          loading="lazy"
          referrerPolicy="no-referrer"
        />
        <span className="project-play">
          <span className="play-icon" aria-hidden="true" />
          播放這個編排
        </span>
      </Link>
      <div className="project-card__body">
        <h3>
          <Link data-explore-card={fromExplore ? project.shareSlug ?? undefined : undefined} to={`/share/${project.shareSlug}`} state={fromExplore ? { fromExplore: true } : undefined} onClick={() => project.shareSlug && onExploreNavigate?.(project.shareSlug)}>{songTitle}</Link>
        </h3>
        <p className="project-card__meta">
          {channel && <span>{channel}</span>}
          <span>編排：{creator}</span>
        </p>
        {project.metricValue !== undefined && <span className="metric-badge">{project.metricPeriod === 'day' ? '今天' : project.metricPeriod === 'week' ? '本週' : '本月'} · {project.metricType === 'views' ? '播放' : '收藏'} {project.metricValue.toLocaleString('en-US')}</span>}
        <span className="project-card__plays">總播放 {(project.playCount ?? 0).toLocaleString('en-US')}</span>
        {project.description && <p>{project.description}</p>}
      </div>
    </article>
  )
}
